import React, { createContext, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { ai, getAppInsights } from './AppInsights';
import { jsx as _jsx } from "react/jsx-runtime";
const LoggingContext = /*#__PURE__*/createContext(null);
const LoggingContextProvider = _ref => {
  let {
    children,
    user,
    appinsightsKey
  } = _ref;
  const [initialised, setIntitialised] = React.useState(false);
  const history = useHistory();
  React.useEffect(() => {
    if (!Boolean(initialised) && Boolean(appinsightsKey) && Boolean(history)) {
      ai.initialize(appinsightsKey, history);
      const appInsights = getAppInsights();
      if (appInsights && user) {
        appInsights.setAuthenticatedUserContext(user.id, user.Username.replace(/\s+/g, ''), true);
      }
      setIntitialised(true);
    }
  }, [initialised, appinsightsKey, history]);
  const createError = error => {
    return {
      name: "Buzz-".concat(error.module, " Error"),
      message: "\n      Module: ".concat(error.module, "\n      Message: ").concat(error.message, "\n      User: ").concat(JSON.stringify(error.user), "\n      Params: ").concat(JSON.stringify(error.params), "\n      Details: ").concat(JSON.stringify(error.details))
    };
  };
  const logError = errorLog => {
    var _getAppInsights;
    const error = createError(errorLog);
    (_getAppInsights = getAppInsights()) === null || _getAppInsights === void 0 || _getAppInsights.trackException({
      exception: error
    });
  };
  return /*#__PURE__*/_jsx(LoggingContext.Provider, {
    value: {
      reactPlugin: ai.reactPlugin,
      appInsights: getAppInsights(),
      logError: logError
    },
    children: children
  });
};
const useLoggingContext = () => useContext(LoggingContext);
export const LoggingContextConsumer = LoggingContext.Consumer;
export { LoggingContext, LoggingContextProvider, useLoggingContext };